import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { generateSessionRoutePath, parseAtomFormatDate } from '../../helpers';
import { APP_ROUTES } from '../../app.config.vars/routes';
import PlayIcon from '../../assets/icons/play.svg';
import PauseIcon from '../../assets/icons/pause.svg';
import PointsIcon from '../../assets/icons/logo_small.svg';
import IconInfoRaw from '../../ui/lconInfoRaw';
export const AdminSessionsList = ({ rallyId, sessions }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    return (_jsx("div", { className: "rally-sessions-list", children: sessions.map((session) => (_jsxs("div", { className: "rally-session-item", children: [_jsxs("div", { className: "rally-session-title", children: [`${t('label.session')} #${session.id}`, _jsx("br", {}), _jsx("span", { children: `${t('label.from')} ${session.firstPlayerName}` })] }), _jsxs("div", { className: "rally-session-columns-group", children: [_jsx(IconInfoRaw, { icon: _jsx(PlayIcon, {}), html: parseAtomFormatDate({
                                dateString: session.startTime,
                                atLabel: t('label.at'),
                                clockLabel: t('label.clock'),
                                locale: i18n.language,
                            }) }), _jsx(IconInfoRaw, { icon: _jsx(PauseIcon, {}), html: parseAtomFormatDate({
                                dateString: session.endTime,
                                atLabel: t('label.at'),
                                clockLabel: t('label.clock'),
                                locale: i18n.language,
                            }) })] }), _jsx(IconInfoRaw, { icon: _jsx(PointsIcon, {}), text: `${session.points} ${t('label.points')}`, className: 'rally-session-info-column points' }), _jsx("div", { className: "rally-session-link link-button", onClick: () => navigate(generateSessionRoutePath(APP_ROUTES.adminRallySessionResults, String(rallyId), String(session.id))), tabIndex: 0, children: t('button.rally_evaluation') })] }, session.id))) }));
};
export default AdminSessionsList;
